import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import Header from "../components/Header"
import { PortalContext } from '../AuthenticatedUser'
import AuthContext from '../context/AuthProvider'
import { deleteDataFromApi, postRequestToApi, registerAction } from '../api';
import Return from '../components/Forum/Return';
import EditableItemsCard2 from '../components/EditableItemsCard2';
import EditableItemForCard2 from '../components/EditableItemForCard2';
import EditableItemForCardEditSelection from '../components/EditableItemForCardEditSelection';
import EditableItemForCardDate from '../components/EditableItemForCardDate';
import Attention from "../images/sun.svg"
import HighlightedMessage from '../components/HighlightedMessage'
import EditIcon from '../images/edit.svg'
import Button from '../components/Button';


export default function UserAccount() {

  const { auth, setAuth, cookies } = React.useContext(AuthContext);
  const { sequenceLength, league, eating, health, loadHealthDataFromAPI, loadEatingDataFromAPI } = React.useContext(PortalContext);

  const [ message, setMessage ] = React.useState(null)

  const [ deleteAccount, setDeleteAccount ] = React.useState(false)
  const [ deleteAccountError, setDeleteAccountError ] = React.useState(null)
  const [ deleteAccountMessage, setDeleteAccountMessage ] = React.useState({ message: '' })

  const [dataModified, setDataModified] = React.useState(0)
  const [passwordModified, setPasswordModified] = React.useState(0)
  const [userHealth, setUserHealth] = React.useState({
    firstName: '',
    lastName: '',
    nickName: '',
    birthDate: '',
    sex: '',
    email: '',
    password: '',
    subscribed: ''
  })
  
  const navigate = useNavigate()

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })
 
  React.useEffect(() => {

    if (!cookies.get("userId")) {
      cookies.set('pageOfInterest', '/health', { path: '/' })
      navigate("/family")
    } else {
      if (!eating) {
        loadEatingDataFromAPI()
      }
      if (!health[+cookies.get("userId")]) {
        loadHealthDataFromAPI(+cookies.get("userId"))
      }
    }
    registerAction(+cookies.get("userId"), "accountpage", auth, cookies)
  }, []);
  
  React.useEffect(() => {
    const id = +cookies.get("userId")

    if (health[id]) {
      setUserHealth({
        firstName: `${health[id].first_name}`,
        lastName: `${health[id].last_name}`,
        nickName: `${(eating && eating?.nickname) ? eating.nickname : ''}`,
        birthDate: `${health[id].birthdate}`,
        sex: `${health[id].sex}`,
        email: `${health[id].email}`,
        subscribed: (health[id].subscribed === true) ? "Sim" : "Não"
        })
    }

  }, [health])
  
  React.useEffect(() => {
    if (dataModified > 0) {

      cookies.set("userName", userHealth.firstName, { path: '/' })

      const body = {
        "id": +cookies.get("userId"),
        "first_name": userHealth.firstName,
        "last_name": userHealth.lastName,
        "nickname": userHealth.nickName,
        "birth_date": userHealth.birthDate,
        "sex": userHealth.sex,
        "email": userHealth.email,
        "subscribed": (userHealth.subscribed === "Sim") ? true : false
      }

      postRequestToApi(body, 'alterprofile', auth, cookies) 
      
      setMessage("Suas modificações foram submetidas com sucesso. A atualização de todas as páginas do portal pode levar alguns minutos")
    }
  }, [dataModified])
  
  React.useEffect(() => {
    if (passwordModified > 0) {

      const body = {
        "id": +cookies.get("userId"),
        "password": userHealth.password
      }
      setMessage("Sua senha foi alterada com sucesso!")

      postRequestToApi(body, 'alterpassword', auth, cookies) 
    }
  }, [passwordModified])
  
  const editUserField = (name, value) => {

    // if value is empty, it does not enter the if statement
    if (value) {
      setUserHealth(prev => ({...prev, [name]: value}))
      
      setDataModified(prev => prev + 1)
    }
  } 

  const editPassword = (name, value) => {

    // if value is empty, it does not enter the if statement
    if (value) {
      setUserHealth(prev => ({...prev, [name]: value}))
      setPasswordModified(prev => prev + 1)
    }
  }
  
  function handleChangeDeleteAccountForm(e) {
    const { name, value } = e.target
    setDeleteAccountMessage({
      [name]: value
    })
  }

  function handleDeleteAccountSubmit(e) {
    e.preventDefault()
    setDeleteAccountError(null)

    if (deleteAccountMessage.message.length === 0 || deleteAccountMessage.message !== "Excluir conta") {
      setDeleteAccountError(`Digite "Exluir conta" corretamente para completar a ação`)
      return
    }

    const body = {
      "id": +cookies.get("userId"),
    }

    registerAction(+cookies.get("userId"), "deleteAccount", auth, cookies)
    deleteDataFromApi(body, 'deletion', auth, cookies) 

    navigate("/loguserout")
  }


  return (
    (!userHealth.firstName) ? 
    <div className="icon-loading-middle-page">
      <img className="small-logo-nav loading-icon" 
          src={require("../images/florence-white-blue.png")} alt="Florence logo"/>
      <p>Carregando página...</p> 
    </div>
    :  
    <>
      <div className={(tabletBreakpoint) ? "container-simple-tablet" : "container-simple"}>
        <Header 
          tabletBreakpoint={false} 
          menuItems="portal" 
          id={+cookies.get("userId")} 
          menuShow={true}
          sequenceLength={sequenceLength}
          hasObjectives={(eating && eating?.goals) ? eating.goals.length > 0 : false}
          league={(league?.is_in_current_league) ? league.is_in_current_league : false}
        />
      </div>
      <>
        <div className={(tabletBreakpoint) ? "container-simple-tablet" : "container-simple"}>

          <div className="top-margin-xl bottom-margin-xs">
            <Return to={`/profile`} backTo="Página inicial"/>
          </div>

          <p className="florence-title bottom-margin-l">Minha Conta</p>
        
          <div className="bottom-margin-m">
            {(message) ?
              <div className="bottom-margin-m">
                <HighlightedMessage icon={Attention} type="warning" header="Atenção" body={message} />
              </div>
              : null }
          </div>

          <EditableItemsCard2 
            clsName="bottom-margin-l"
            title="Perfil"
            icons={false}
          >
            <EditableItemForCard2 edit={false} inputType="email" userField={["email"]} editUserField={editUserField} placeholder={["Digite e-mail"]}>
              <p className="body"><strong>E-mail: </strong>{userHealth.email}</p>
            </EditableItemForCard2>
            <EditableItemForCard2 edit={true} userField={["firstName"]} editUserField={editUserField} placeholder={["Digite seu nome"]}>
              <p className="body"><strong>Nome: </strong>{`${userHealth.firstName}`}</p>
            </EditableItemForCard2>
            <EditableItemForCard2 edit={true} userField={["nickName"]} editUserField={editUserField} placeholder={["Digite seu nome"]}>
              <p className="body"><strong>Apelido: </strong>{`${userHealth.nickName}`}</p>
            </EditableItemForCard2>
            <EditableItemForCard2 
                edit={true} 
                userField={["lastName"]} 
                editUserField={editUserField} 
                placeholder={["Digite seu sobrenome"]}
              >
              <p className="body"><strong>Sobrenome: </strong>{`${userHealth.lastName}`}</p>
            </EditableItemForCard2>
            <EditableItemForCardDate edit={true} userField={["birthDate"]} editUserField={editUserField} >
              <p className="body"><strong>Data de nascimento: </strong>{userHealth.birthDate}</p>
            </EditableItemForCardDate>
            <EditableItemForCardEditSelection
                  edit={true} 
                  userField={["sex"]}
                  editUserField={editUserField} 
                  responseOptions={["Masculino", "Feminino", "Outro"]}
                  gridClass="content-two-columns">
                <p className="body"><strong>Sexo: </strong>{userHealth.sex}</p>
            </EditableItemForCardEditSelection>
            <EditableItemForCardEditSelection
                  edit={true} 
                  userField={["subscribed"]}
                  editUserField={editUserField} 
                  responseOptions={["Sim", "Não"]}
                  gridClass="content-two-columns">
                <p className="body"><strong>Receber lembretes por e-mail: </strong>{userHealth.subscribed}</p>
            </EditableItemForCardEditSelection>
            <EditableItemForCard2 edit={true} inputType="password" userField={["password"]} editUserField={editPassword} placeholder={["Digite sua nova senha"]}>
              <p className="body"><strong>Alterar senha </strong></p>
            </EditableItemForCard2>

          <div 
            className={`editable-item-for-card-red top-margin-xs vertical-padding-xs left-padding-s right-padding-xs`}>
              <div>
                <div className='editable-item-for-card-header'>
                  <div><p className="body"><strong>Excluir conta</strong></p></div>
                  <div className="row-svg-icons left-margin-xs">
                    <button onClick={()=>{setDeleteAccount(prev=>!prev)}} className='carousel-btn'>
                      <img className="" src={EditIcon}/>
                    </button>
                  </div>
                </div> 
                {(!deleteAccount) ?
                <div>

                  {(deleteAccountError !== null) && 
                  <HighlightedMessage icon={Attention} type="warning" header="Atenção" body={deleteAccountError} />}

                  <form onSubmit={handleDeleteAccountSubmit}>
                    <p className="body top-margin-xs">
                      <strong>Atenção: </strong>
                      Essa é uma ação destrutiva e não pode ser desfeita.
                      Sua conta e todos os dados associados a ela serão excluídos e não poderão mais ser recuperados.
                    </p>

                    <p className="body top-margin-xs">
                      Caso queira prosseguir, digite no campo abaixo 
                      <strong> Exluir conta</strong>, e clique no botão "Excluir".
                    </p>

                    <div className="top-margin-s bottom-margin-xs">
                      <textarea 
                        className="profile-question-form form-full-width shorter-form " 
                        name="message" 
                        onChange={handleChangeDeleteAccountForm}
                        placeholder={"Excluir conta"}
                        value={(deleteAccountMessage.message) ? deleteAccountMessage.message : ''} 
                      />
                    </div>

                    <>
                      <Button type="primary right-margin-s">Deletar</Button>
                      <Button type="tertiary" buttonType="button" onClick={()=>setDeleteAccount(prev=>!prev)}>Cancelar</Button>
                    </>
                  </form>
                </div> 
                : null }
              </div>
            </div>

          </EditableItemsCard2>
        </div>
      </>
    </>
  )
}
